import React from "react";
import { Doughnut } from "react-chartjs-2";
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip as ChartTooltip,
    Legend,
} from "chart.js";

ChartJS.register(ArcElement, ChartTooltip, Legend);

interface ISmallPieChartProps {
    data: {
        labels: string[];
        data: number[];
        colors: string[];
    };
}

const SmallPieChart: React.FC<ISmallPieChartProps> = ({ data }) => {
    const chartData = {
        labels: data.labels,
        datasets: [
            {
                data: data.data,
                backgroundColor: data.colors,
                borderWidth: 0,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                enabled: true,
            },
        },
    };

    return (
        <div style={{ height: "80px", width: "80px", margin: "0 auto" }}>
            <Doughnut data={chartData} options={options} />
        </div>
    );
};

export default SmallPieChart;